"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _reactRedux = require("react-redux");
var _useAppConfiguration2 = _interopRequireDefault(require("@deosite/app/features/appConfiguration/useAppConfiguration"));
var _checkoutDataSlice = require("@deosite/app/features/checkoutData/checkoutDataSlice");
var _excluded = ["email"],
  _excluded2 = ["email"]; //Tutaj hook dla Api tylko, nie moze byc np. uzyty ten sam @deosite/hooks on korzysta miedzyinnymi z z useCart itd nested cycle. Teraz powielony kod w stosunku do @deosite/hooks, ale teraz jest mix, jakby cart podeszedl do reduxa by bylo ladniej :)
var useCheckoutData = function useCheckoutData() {
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state.checkoutData;
    }),
    email = _useSelector.email,
    billingAddress = _useSelector.billingAddress,
    shippingAddress = _useSelector.shippingAddress,
    shippingAddressSameAsBilling = _useSelector.shippingAddressSameAsBilling,
    additionalInformation = _useSelector.additionalInformation,
    emailConsentForDelivery = _useSelector.emailConsentForDelivery;
  var _useAppConfiguration = (0, _useAppConfiguration2["default"])(),
    language = _useAppConfiguration.language;
  var dispatch = (0, _reactRedux.useDispatch)();
  var updateOrderId = function updateOrderId(orderId) {
    dispatch((0, _checkoutDataSlice.setOrder)(orderId));
  };
  var setAddressOnSubmit = function setAddressOnSubmit(values) {
    dispatch((0, _checkoutDataSlice.setAddresses)(values));
  };
  var setBillingCountryFromCart = function setBillingCountryFromCart() {
    if (window === undefined) {
      return;
    }
    var accountData = JSON.parse(sessionStorage.getItem("accountData"));
    if (billingAddress.country.id) {
      return;
    }
    var _ref = accountData !== null && accountData !== void 0 ? accountData : {},
      emailStorage = _ref.email,
      billing = _ref.billingAddress,
      shipping = _ref.shippingAddress,
      customer = _ref.customer;
    if (emailStorage) {
      dispatch((0, _checkoutDataSlice.setEmail)(emailStorage));
    }
    if (billing) {
      var _email = billing.email,
        billingWithoutEmail = (0, _objectWithoutProperties2["default"])(billing, _excluded);
      dispatch((0, _checkoutDataSlice.setBillingAddress)(billingWithoutEmail));
    } else {
      dispatch((0, _checkoutDataSlice.setBillingCountry)(language.toUpperCase()));
    }
    if (shipping) {
      var _email2 = shipping.email,
        shippingWithoutEmail = (0, _objectWithoutProperties2["default"])(shipping, _excluded2);
      dispatch((0, _checkoutDataSlice.setShippingAddress)(shippingWithoutEmail));
    } else {
      dispatch((0, _checkoutDataSlice.setShippingCountry)(language.toUpperCase()));
    }
  };
  return {
    email: email,
    billingAddress: billingAddress,
    shippingAddress: shippingAddress,
    clearData: function clearData() {
      return dispatch((0, _checkoutDataSlice.clearData)());
    },
    setBillingCountry: function setBillingCountry(country) {
      return dispatch((0, _checkoutDataSlice.setBillingCountry)(country.toUpperCase()));
    },
    setShippingCountry: function setShippingCountry(country) {
      return dispatch((0, _checkoutDataSlice.setShippingCountry)(country.toUpperCase()));
    },
    shippingAddressSameAsBilling: shippingAddressSameAsBilling,
    setShippingAddressSameAsBilling: function setShippingAddressSameAsBilling(bool) {
      return dispatch((0, _checkoutDataSlice.setShippingAddressSameAsBilling)(bool));
    },
    setEmailConsentForDelivery: function setEmailConsentForDelivery(bool) {
      return dispatch((0, _checkoutDataSlice.setEmailConsentForDelivery)(bool));
    },
    additionalInformation: additionalInformation,
    emailConsentForDelivery: emailConsentForDelivery,
    setAdditionalInformation: function setAdditionalInformation(text) {
      return dispatch((0, _checkoutDataSlice.setAdditionalInformation)(text));
    },
    setAddressOnSubmit: setAddressOnSubmit,
    setEmail: function setEmail(email) {
      return dispatch((0, _checkoutDataSlice.setEmail)(email));
    },
    updateOrderId: updateOrderId,
    setBillingCountryFromCart: setBillingCountryFromCart
  };
};
var _default = useCheckoutData;
exports["default"] = _default;